import clsx from "clsx";
import { ExternalUserStatusLabels } from "models/types";
import "./styles.scss";

export default function ApplicationStatusLabel({ status }: { status: string }) {
	return (
		<div
			className={clsx("status-label", {
				"status-analysis": status === ExternalUserStatusLabels.ANDAMENTO,
				"status-new-message": status === ExternalUserStatusLabels.MENSAGEM_RECEBIDA,
				"status-cancelled": status === ExternalUserStatusLabels.CANCELADO,
				"status-approved": status === ExternalUserStatusLabels.APROVADO,
				"status-rejected": status === ExternalUserStatusLabels.REPROVADO
			})}
		>
			{status}
		</div>
	);
}
